export {
	PayPalBnplMessage,
	type PayPalBnplMessageProps
} from "./PayPalBnplMessage";
